import { PropsWithChildren } from 'react'

export const Root = ({ children }: PropsWithChildren<{}>) => {
  return (
    <div className="h-full flex flex-col justify-between p-8 pt-16">
      {children}
    </div>
  )
}
